













import { Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { Routes } from '@/router/routes'

@Component
export default class TaxesTableHeader extends Vue {
  routes = Routes
}
